import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="copyright">
        &copy; 
        <strong>
          <span>2026 securecontrol</span>
        </strong>
        . All Rights Reserved
      </div>
      <div className="credits">
        Designed by{" "}
        <a href="https://icontinuum.net/" target="_blank" rel="noreferrer">
          Icontinuum
        </a>
      </div>
    </footer>
  );
};

export default Footer;
